import React from 'react';
import styles from './index.module.scss';

const Status = ({ className }) => {
    return (
        <svg
            id='Opened_2'
            data-name='Opened 2'
            xmlns='http://www.w3.org/2000/svg'
            width='94'
            height='94'
            viewBox='0 0 94 94'
            className={className}
        >
            <circle
                id='Ellipse_18'
                data-name='Ellipse 18'
                cx='47'
                cy='47'
                r='47'
                transform='translate(0 0)'
                className={styles.circle}
            />
            <g id='Group_3735' data-name='Group 3735' transform='translate(-557 16.967)'>
                <path
                    id='Subtraction_7'
                    data-name='Subtraction 7'
                    d='M30,29H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H22.5A11.031,11.031,0,0,0,32,9.479V27A2,2,0,0,1,30,29Z'
                    transform='translate(585.999 20.001)'
                    className={styles.icon}
                />
                <path
                    id='Path_3282'
                    data-name='Path 3282'
                    d='M1476.116-989.688a7.308,7.308,0,0,1-7.31,7.307,7.3,7.3,0,0,1-7.305-7.307,7.306,7.306,0,0,1,7.305-7.31,7.311,7.311,0,0,1,7.31,7.31'
                    transform='translate(-849.193 1007.998)'
                    className={styles.icon}
                    fillRule='evenodd'
                />
            </g>
        </svg>
    );
};

export default Status;
